import React from 'react';
import { translate } from '../../../../../common/intl';
import WhiteLabelingManagementContainer from '../../../../user.management/profile/whiteLabeling.management/WhiteLabelingManagement.container';
import SettingsPanel from '../../components/Panels';
import { SettingsPanelProps } from '../../types';

const ApprovalRequestsSettingsPanel: React.FC<SettingsPanelProps> = (props) => {
  return (
    <SettingsPanel {...props} title={translate('administration.company.information.panel.title.logo')}>
      <WhiteLabelingManagementContainer />
    </SettingsPanel>
  );
};

export default ApprovalRequestsSettingsPanel;
